module.exports = __webpack_public_path__ + "img/WDBC-Logo-718x609.6109ef0f.png";